import React from "react";
import moment from "moment";
import {
    RenderCurrency,
    RenderDollar,
} from "../../../../Utils/renderField/renderReadField";
import { BITACORA_FLETE_AJENO } from "../../../../../../utility/constants";

export const BitacoraFletesTable = ({ registros }) => {
    // El flete ajeno se cobra en quetzales y el propio en dólares por kg seco
    const renderMonto = (registro, monto) => {
        const esAjeno = registro.ambito_flete === BITACORA_FLETE_AJENO;

        if (esAjeno) {
            return <RenderCurrency value={monto} decimalScale={3} />;
        }

        return <RenderDollar value={monto} decimalScale={3} />;
    };

    // Los registros de creación de la finca no tienen valores anteriores
    const renderAnterior = (contenido) => (
        <div className="bitacora-fletes__valor-anterior">
            Antes: {contenido}
        </div>
    );

    const renderPrecio = (registro) => {
        const cambioPrecio =
            registro.precio_anterior !== null &&
            registro.precio_anterior !== undefined &&
            registro.precio_anterior !== registro.precio_vigente;

        return (
            <React.Fragment>
                {renderMonto(registro, registro.precio_vigente)}
                {cambioPrecio &&
                    renderAnterior(
                        renderMonto(registro, registro.precio_anterior),
                    )}
            </React.Fragment>
        );
    };

    const renderTipoFlete = (registro) => {
        if (!registro.tipo_costo_flete_vigente_nombre) {
            return <span className="text-muted">No aplica</span>;
        }

        const cambioTipo =
            registro.tipo_costo_flete_anterior_nombre &&
            registro.tipo_costo_flete_anterior_nombre !==
                registro.tipo_costo_flete_vigente_nombre;

        return (
            <React.Fragment>
                {registro.tipo_costo_flete_vigente_nombre}
                {cambioTipo &&
                    renderAnterior(registro.tipo_costo_flete_anterior_nombre)}
            </React.Fragment>
        );
    };

    return (
        <div className="new-table-wrapper bitacora-fletes__table-wrapper">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th>Fecha del cambio</th>
                        <th className="text-right">Precio</th>
                        <th>Flete</th>
                        <th>Tipo de flete</th>
                        <th>Materia prima</th>
                        <th>Usuario que modificó</th>
                    </tr>
                </thead>
                <tbody>
                    {registros.length === 0 && (
                        <tr>
                            <td colSpan={7} className="text-center">
                                La finca no tiene cambios registrados en sus
                                precios de flete
                            </td>
                        </tr>
                    )}
                    {registros.map((registro) => (
                        <tr key={registro.id}>
                            <td className="text-center text-nowrap">
                                {moment(registro.fecha_creacion).format(
                                    "DD/MM/YYYY - HH:mm",
                                )}
                            </td>
                            <td className="text-right text-nowrap">
                                {renderPrecio(registro)}
                            </td>
                            <td className="text-center">
                                {registro.ambito_flete_nombre}
                            </td>
                            <td className="text-center">
                                {renderTipoFlete(registro)}
                            </td>
                            <td className="text-center">
                                {registro.materia_prima_nombre}
                            </td>
                            <td className="text-center">
                                {registro.usuario_nombre
                                    ? registro.usuario_nombre
                                    : "---"}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
